import React from "react";
import "./TamperPricingSection.css";
import PricingCard1 from "../images/PricingCard1.svg";
import PricingCard2 from "../images/PricingCard2.svg";

const TamperPricingSection = () => {

  const handleScrollToFooter = () => {
    const footer = document.getElementById("tamper-form");
    if (footer) {
      footer.scrollIntoView({ behavior: "smooth" });
    }
  };


  return (
    <div className="pricing-container">
      <h2 className="pricing-title">
        <span>Pricing</span> Tailored only for You!
      </h2>

      <div className="pricing-cards">
        {/* Advance Plan */}
        <div
          className="pricing-card advance"
          style={{ backgroundImage: `url(${PricingCard1})` }}
        >
          <div className="pricing-card-content">
            <div>
              <h3>Advance</h3>
              <p className="price">
                $25.00
                <span className="small-grey-text">$33.00</span>
                <span className="discount">25% OFF</span>
              </p>
              <p className="credits">500 Credits</p>
            </div>
            <div className="features">
              <div className="key-feature">Key Feature</div>
              <div className="features-points">
                <img src="/images/tick-circle (1).svg" alt="" />
                <p> Tampering Check</p>
              </div>
              <div className="features-points">
                <img src="/images/tick-circle (1).svg" alt="" />
                <p> Metadata Check</p>
              </div>
              <div className="features-points">
                <img src="/images/tick-circle (1).svg" alt="" />
                <p> Structural Change Check</p>
              </div>
              <div className="features-points">
                <img src="/images/tick-circle (1).svg" alt="" />
                <p>Editor revealing</p>
              </div>
            </div>
          </div>
          <button className="btn" onClick={handleScrollToFooter}>Buy Now</button>
        </div>

        {/* Supreme Plan */}
        <div
          className="pricing-card2 supreme supreme-card"
          style={{ backgroundImage: `url(${PricingCard2})` }}
        >
          <div className="pricing-card-content">
            <div>
              <h3>Supreme</h3>
              <p className="price">
                $50.00
                <span className="small-grey-text">$75.00</span>
                <span className="discount">45% OFF</span>
              </p>
              <p className="credits">500 Credits</p>
            </div>
            {/* Features */}
            <div className="features">
              <div className="key-feature">Key Feature</div>
              <div className="features-points">
                <img src="/images/tick-circle (1).svg" alt="" />
                <p> Tampering Check</p>
              </div>
              <div className="features-points">
                <img src="/images/tick-circle (1).svg" alt="" />
                <p> Metadata Check</p>
              </div>
              <div className="features-points">
                <img src="/images/tick-circle (1).svg" alt="" />
                <p> Structural Change Check</p>
              </div>
              <div className="features-points">
                <img src="/images/tick-circle (1).svg" alt="" />
                <p>Editor revealing</p>
              </div>
              <div className="features-points">
                <img src="/images/tick-circle (1).svg" alt="" />
                <p>Suspected Text Reveal</p>
              </div>
              <div className="features-points">
                <img src="/images/tick-circle (1).svg" alt="" />
                <p>Digital Signature Analysis</p>
              </div>
              <div className="features-points">
                <img src="/images/tick-circle (1).svg" alt="" />
                <p>Embedded Files Analysis</p>
              </div>
            </div>
          </div>
          <button className="supreme-btn" onClick={handleScrollToFooter}>Buy Now</button>
        </div>

        {/* Enterprise Plan */}
        <div
          className="pricing-card enterprise"
          style={{ backgroundImage: `url(${PricingCard1})` }}
        >
          <div className="pricing-card-content">
            <div>
              <h3>EnterPrise</h3>
              {/* <p className="price">
                $25.00
                <span className="small-grey-text">$33.00</span>
                <span className="discount">25% OFF</span>
              </p>
              <p className="credits">500 Credits</p> */}
            </div>
            <div className="features">
              {/* <div className="key-feature">Key Feature</div> */}
              <div className="features-points">
                <img src="/images/tick-circle (1).svg" alt="" />
                <p>All Supreme features, enterprise-optimized.</p>
              </div>
              <div className="features-points">
                <img src="/images/tick-circle (1).svg" alt="" />
                <p>Seamless API integration for B2B SaaS.</p>
              </div>
              <div className="features-points">
                <img src="/images/tick-circle (1).svg" alt="" />
                <p>Unlimited scalability, users, and API calls.</p>
              </div>
              <div className="features-points">
                <img src="/images/tick-circle (1).svg" alt="" />
                <p>Real-time analytics and  insights.</p>
              </div>
            </div>
          </div>

          <button className="btn" onClick={handleScrollToFooter}>Contact Sales</button>
        </div>
      </div>

      <div className="note-section">
        <div className="note-section-container">
          <p> 👉</p>
          <p>PDFs up to 5 pages cost 1 credit.</p>
        </div>
        <div className="note-section-container">
          <p> 👉</p>
          <p>
            PDFs over 5 pages are counted in sets of 5, rounded up. Example: 7
            pages = 2 credits.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TamperPricingSection;
